import komuneLogo from '@/assets/img/logo/KomuneCare_Logo.png';
import careLogo from '@/assets/img/logo/pdf_logo.png';
import theMansionLogo from '@/assets/img/logo/themansion.png';

export const CompanyHash = {
	"1435752V" :{		
		templateName: "Care Guardian",
		companyName: "Care Guardian Sdn Bhd",
		companyCode: "1435752V",
		companyLogo: careLogo,
		companyAddress1: "A-1-2, Level 2, Block A, Jaya One, Jalan Profesor Diraja Ungku Aziz",
		companyAddress2: "46200 Petaling Jaya, Malaysia",
		telephone: "1300-22-8822 (Hotline)",
		email: "contact@mycareconcierge.com",
		website: "http://www.mycareconcierge.com",
		tncUrl: "https://www.mycareconcierge.com/",
		bankType: "CIMB BANK",
		companyBankAccount: "8010948703",
		companyBankName: "CARE GUARDIAN SDN BHD",
		externalNote: 
`For payment via Fund Transfer, kindly provide the bank in slip via email to sales@mycareconcierge.com or to your Care
Manager. All payments are to be made prior to the commencement of any caregiving services. If you have any questions
regarding this invoice, please contact your Care Manager.

We reserve the right to charge 1.5% interest per month on the invoiced amount for overdue invoices
`,
		tax: 0,
	},
	"642089-X":{		
		templateName: "Ritchie",
		companyName: "Sawara Ampang Care Centre Sdn Bhd", 
		companyCode: "642089-X",
		companyLogo: theMansionLogo,
		companyAddress1: "No 333, Persiaran Ritchie, Desa Pahlawan",
		companyAddress2: "55000 Kuala Lumpur, Malaysia",
		telephone: "1300-22-8822 (Hotline)",
		email: "contact@mycareconcierge.com",
		website: "https://www.themansion.com.my",
		tncUrl: "https://www.mycareconcierge.com/",
		companyBankAccount: "8010721544",
		bankType: "CIMB BANK",
		companyBankName: "SAWARA AMPANG CARE CENTRE SDN. BHD.",
		externalNote:
`For payment via Fund Transfer, kindly provide the bank in slip or sales invoice number on recipient's reference, via email to
finance.invoice@mycareconcierge.com
Kindly make all payments within 7 days from the date of this invoice. If you have any questions, please do not hesitate to contact
us.
We reserve the right to change 1.5% interest per month on the invoiced amount for overdue invoices.
`,
		tax: 0,
	},
	"202101014451":{		
		templateName: "Komune Care",
		companyName: "Komune Care Centre Sdn Bhd", 
		companyCode: "202101014451",
		companyLogo: komuneLogo,
		companyAddress1: "Komune Living & Wellness, 21, Jalan Tasik Permaisuri 2",
		companyAddress2: "Bandar Tun Razak, 56000 Kuala Lumpur, Malaysia",
		telephone: "1300-22-8822 (Hotline)",
		email: " contact@mycareconcierge.com",
		website: "http://www.komunecare.com",
		tncUrl: "",
		companyBankAccount: "8010839356",
		bankType: "CIMB BANK",
		companyBankName: "KOMUNE CARE CENTRE SDN BHD",
		externalNote:
`For payment via Fund Transfer, kindly provide the bank in slip or sales invoice number on recipient's reference, via email to
finance.komunecare@mycareconcierge.com
Kindly make all payments within 7 days from the date of this invoice. If you have any questions, please do not hesitate to contact
us.
We reserve the right to change 1.5% interest per month on the invoiced amount for overdue invoices.
`,
		tax: 0,
	},
  "1214920-M":{		
		templateName: "Sawara Care",
		companyName: "Sawara Care Centre Sdn. Bhd.", 
		companyCode: "1214920-M",
		companyLogo: theMansionLogo,
		companyAddress1: "136, Jalan Gasing,",
		companyAddress2: "46000 Petaling Jaya, Malaysia",
		telephone: "1300-22-8822 (Hotline)",
		email: " contact@mycareconcierge.com",
		website: "http://www.themansion.com",
		tncUrl: "",
		companyBankAccount: "8008453738",
		bankType: "CIMB BANK",
		companyBankName: "SAWARA CARE CENTRE SDN. BHD.",
		externalNote:
`For payment via Fund Transfer, kindly provide the bank in slip or sales invoice number on recipient's reference, via email to
finance.invoice@mycareconcierge.com
Kindly make all payments within 7 days from the date of this invoice. If you have any questions, please do not hesitate to contact
us.
We reserve the right to change 1.5% interest per month on the invoiced amount for overdue invoices.
`,
		tax: 0,
	},
  "1325156-A":{		
		templateName: "Sawara Spring Care",
		companyName: "Sawara Spring Care Centre Sdn. Bhd.", 
		companyCode: "1325156-A",
		companyLogo: theMansionLogo,
		companyAddress1: "58, Jalan Gasing, Bukit Gasing,",
		companyAddress2: "46000 Petaling Jaya, Malaysia",
		telephone: "1300-22-8822 (Hotline)",
		email: " contact@mycareconcierge.com",
		website: "http://www.themansion.com",
		tncUrl: "",
		companyBankAccount: "8010015592",
		bankType: "CIMB BANK",
		companyBankName: "SAWARA SPRING CARE CENTRE SDN. BHD.",
		externalNote:
`For payment via Fund Transfer, kindly provide the bank in slip or sales invoice number on recipient's reference, via email to
finance.invoice@mycareconcierge.com
Kindly make all payments within 7 days from the date of this invoice. If you have any questions, please do not hesitate to contact
us.
We reserve the right to change 1.5% interest per month on the invoiced amount for overdue invoices.
`,
		tax: 0,
	},
  "1435751U":{		
		templateName: "Care Resources",
		companyName: "CARE CONCIERGE RESOURCES SDN BHD", 
		companyCode: "1435751U",
		companyLogo: careLogo,
		companyAddress1: "A-1-2, Block A, Jaya One, Jalan Profesor Diraja Ungku Aziz,",
		companyAddress2: "46200 Petaling Jaya, Malaysia",
		telephone: "1300-22-8822 (Hotline)",
		email: " contact@mycareconcierge.com",
		website: "http://www.themansion.com",
		tncUrl: "",
		companyBankAccount: "8010946747",
		bankType: "CIMB BANK",
		companyBankName: "CARE CONCIERGE RESOURCES SDN BHD",
		externalNote:
`For payment via Fund Transfer, kindly provide the bank in slip or sales invoice number on recipient's reference, via email to
finance@mycareconcierge.com
Kindly make all payments within 7 days from the date of this invoice. If you have any questions, please do not hesitate to contact
us.
We reserve the right to change 1.5% interest per month on the invoiced amount for overdue invoices.
`,
		tax: 0,
	},
}

export const CentreList = [
  {
    id: 0,
    centreName: "Unassigned",
    label: "Unassigned",
    value: 0,
    isDisabled: false
  },
  {
    id: 1,
    centreName: "TM Gasing 136",
    label: "TM Gasing 136",
    value: 1,
    isDisabled: false
  },
  {
    id: 2,
    centreName: "TM Sri Aman",
    label: "TM Sri Aman",
    value: 2,
    isDisabled: false
  },
  {
    id: 3,
    centreName: "TM Gasing 60",
    label: "TM Gasing 60",
    value: 3,
    isDisabled: false
  },
  {
    id: 4,
    centreName: "Komune Care",
    label: "Komune Care",
    value: 4,
    isDisabled: false
  },
  {
    id: 5,
    centreName: "TPR Penang",
    label: "TPR Penang",
    value: 5,
    isDisabled: false
  },
  {
    id: 6,
    centreName: "HomeCare",
    label: "HomeCare",
    value: 6,
    isDisabled: false
  },
  {
    id: 7,
    centreName: "TM Ritchie",
    label: "TM Ritchie",
    value: 7,
    isDisabled: false
  },
  {
    id: 8,
    centreName: "Demo Company (Xero Development)",
    label: "Demo Company (Xero Development)",
    value: 8,
    isDisabled: false
  },
  {
    id: 9,
    centreName: "Angsana Home",
    label: "Angsana Home",
    value: 9,
    isDisabled: false
  },
  {
    id: 10,
    centreName: "Ara Woods",
    label: "Ara Woods",
    value: 10,
    isDisabled: false
  },
  {
    id: 11,
    centreName: "Jaya One Daycare",
    label: "Jaya One Daycare",
    value: 11,
    isDisabled: false
  },
  {
    id: 12,
    centreName: "Academy Care",
    label: "Academy Care",
    value: 12,
    isDisabled: false
  },
  {
    id: 13,
    centreName: "Care Collective",
    label: "Care Collective",
    value: 12,
    isDisabled: false
  },
  {
    id: 14,
    centreName: "Care Lux (Oakwood project)",
    label: "Care Lux (Oakwood project)",
    value: 14,
    isDisabled: false
  }
];

export const centreMap = CentreList.reduce((acc, centre) => {
  acc[centre.id] = centre.centreName;
  return acc;
}, {});

export const CenterHashCompanyList = {
  1: CompanyHash["1214920-M"], // Sawara Care Centre
  2: CompanyHash["1325156-A"], // Sawara Spring Care Centre
  3: CompanyHash["1325156-A"], // Sawara Spring Care Centre
  4: CompanyHash["202101014451"], // Komune CARE
  5: CompanyHash["1214920-M"], // Sawara Care Centre
  6: CompanyHash["1435752V"], // CARE Guaardian
  7: CompanyHash["642089-X"], // Sawara Ampang Care Centre
  9: CompanyHash["1214920-M"], // Sawara Care Centre
  10: CompanyHash["1214920-M"], // Sawara Care Centre
  11: CompanyHash["1214920-M"], // Sawara Care Centre
  12: CompanyHash["1435751U"], // Care Concierge Resources Sdn. 
}

export const isValidCenter = (centre) => {
  if (centre === null || centre === undefined) return false;
  return Object.prototype.hasOwnProperty.call(CenterHashCompanyList, centre);
};

export const getCustomerCenter = (data) => {
  if (data?.centre_list_with_biz_id && data?.centre_list_with_biz_id?.length > 0) {
      const validCentres = [...new Set(data.centre_list_with_biz_id
          .map(item => item.centre)
          .filter(isValidCenter))];  // Filter out invalid centres
      if (validCentres.length > 0) {
          return validCentres.join(',');
      }
  }
  if (data?.centre_list?.length > 0) {
    const validCentres = [
        ...new Set(
            data.centre_list
                .map(item => item.centre) 
                .filter(isValidCenter)
        )
    ];

    if (validCentres.length > 0) {
        return validCentres.join(',');
    }
  }
  if (isValidCenter(data?.centre)) {
      return data?.centre?.toString() ?? '0';
  }
  return '0';
};